import { render, staticRenderFns } from "./tiktok_prize_table.vue?vue&type=template&id=0fccaa8e&scoped=true"
import script from "./tiktok_prize_table.vue?vue&type=script&lang=ts"
export * from "./tiktok_prize_table.vue?vue&type=script&lang=ts"
import style0 from "./tiktok_prize_table.vue?vue&type=style&index=0&id=0fccaa8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fccaa8e",
  null
  
)

export default component.exports